import { mapState } from 'vuex';

export default {
    name: 'listcontrols',
    
    props: {
        searchvalue : String,
        count : Number,
        sorting : Object,
        listdate : {
            type : Array,
            default : () => {return []}
        },
        sortvalue : String,
        activity : String,
        datepicker : Object,
        store : String,
        filters : Object,
        filterValues : Object,
        dfilterValues : Object,
        payloadsSamples : Object,
        payloadsSample : String,
    },


    data : function(){

        return {
            loading : false,
        }

    },

    created (){
        this.load()
    },

    watch: {
        listdate : function(){
            this.save()
        },
        sortvalue : function(){
            this.save()
        },
        searchvalue : function(){
            this.save()
        },
        filterValues : function(){
            this.save()
        }, 
        payloadsSample : function(){
            this.save()
        }, 


    },
    computed: {
        date: {
            get() {
                return this.listdate
            },
            set(value) {
                this.$emit('date', value)
            }
        },

        filtersApplyied : function(){
            return JSON.stringify(this.filterValues) != JSON.stringify(this.dfilterValues)
        },

        ...mapState({
            auth : state => state.auth,
        })
    },
    

    methods : {
        search : function(v){
            this.$emit('search', v)
        },
        payloadsSampleChange : function(v){
            this.$emit('payloadsSampleChanged', v)
        },
        sort : function(e){
            this.$emit('sort', e.target.value)

        },


        load : function(){

            if (this.store){

                this.core.settings.ui.setmetaOne('listcontrols_' + this.store, {
                    name: 'listcontrols_' + this.store,
                    default: function() {
                        return {
                            sortvalue : null,
                            date : [],
                            searchvalue : '',
                            payloadsSample : ''
                        }
                    },
                })

                this.core.settings.ui.getall()

                var values = this.core.settings.ui.get('listcontrols_' + this.store).value

                console.log('values', values)

                values.searchvalue = ''

                if (values.sortvalue) this.$emit('sort', values.sortvalue)
                if (values.searchvalue) this.$emit('search', values.searchvalue)
                if (values.filters) this.$emit('filtering', values.filters)
                if (values.payloadsSample) this.$emit('payloadsSampleChanged', values.payloadsSample)
                    
                if (_.isEmpty(values.date)) this.$emit('date', values.date)
            }

        },

        save : function(){
            if(this.store){
                
                console.log('values', {
                        sortvalue : this.sortvalue,
                        date : this.date,
                        searchvalue : this.searchvalue,
                        filters : this.filterValues,
                        payloadsSample : this.payloadsSample
                    })


                setTimeout(() => {
                    this.core.settings.ui.set('listcontrols_' + this.store, {
                        sortvalue : this.sortvalue,
                        date : this.date,
                        searchvalue : this.searchvalue,
                        filters : this.filterValues,
                        payloadsSample : this.payloadsSample
                    })
                }, 100)

                
            }
        },

        showfilters : function(){

            this.core.vueapi.editcustom(
                
                {
                    schema : this.filters, 
                    values: this.filterValues, 
                    caption : "Filter", 
                    mclass : "filters",
                    ignoreerrors : true

                }, (values) => {
                
                this.$emit('filtering', values)
            })

        }
    },
}